// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__QMqeN","search":"Settings_search__1zyBB","filter":"Settings_filter__3av5S"};